// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"6":"57bb9ec0","641":"7a61752c"}[chunkId] + ".chunk.js");